// export const getAPIUrl = () => {
//   if (window.location.host.startsWith("localhost")) {
//     return 'http://localhost:4000';
//   } else {
//     return 'https://monitor-api.remotexs.co';
//   }
// };
// export const title = "RemoteXS Monitor";


export const getAPIUrl = () => {
  if (window.location.host.startsWith("localhost")) {
    // return 'https://api-monitor.systemq.pyther.com';
    return 'http://127.0.0.1:7070';
  } else if (window.location.host.startsWith("monitor-systemq.pyther.com") || window.location.host.startsWith("monitor.shalby.pyther.com")) {
    return 'https://api.monitor-systemq.pyther.com';
  } else {
    return 'http://127.0.0.1:7070';
  }
};
export const title = "SystemQ Monitor";
